module.exports = __webpack_public_path__ + "img/logo-flority.0977b95a.png";